module.exports = __webpack_public_path__ + "static/media/6.72f64d67.gif";